module.exports = __webpack_public_path__ + "media/Homepage_mobile.d5c52115.mp4";